import React, { useCallback, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { faGridDividers } from '@fortawesome/pro-regular-svg-icons/faGridDividers';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { Button } from 'ui-components/components/button';
import { Popover } from 'ui-components/components/popover';
import { noop } from 'ui-components/default-props/noop';

import messages from './messages';
import GroupByPopover from './popover';
import Global from '../../../store/global-selectors';
import { FilterBarButton } from '../../filter-bar-button';
import style from '../grid-header.module.less';
import buttonStyle from './style.module.less';

const GroupByButton = ({ onGroupByChanged = noop, showIconButton = false }) => {
  const activeGroupBys = useSelector(Global.selectOrdersGridActiveGroupByEnums);
  const [popoverIsOpen, setPopoverIsOpen] = useState(false);

  const togglePopover = useCallback(() => setPopoverIsOpen((val) => !val), []);

  return (
    <Popover
      appendTarget={document.querySelector('#app-root')}
      body={<GroupByPopover closePopover={togglePopover} onGroupByChanged={onGroupByChanged} />}
      enterExitTransitionDurationMs={0}
      isOpen={popoverIsOpen}
      popoverTipShapeStyles='fill: #EEEEEE'
      preferPlace='below'
    >
      {showIconButton ? (
        <FilterBarButton icon={faGridDividers} isActive={!!activeGroupBys.length} label={messages.groupByLabel} onClick={togglePopover} />
      ) : (
        <Button
          className={classnames(style['action-button'], {
            [buttonStyle.active]: popoverIsOpen,
          })}
          onClick={togglePopover}
          pendoTrackingId='/orders#group-by-button'
          theme='ghost'
        >
          <FormattedMessage {...messages.groupByText} />
          {activeGroupBys.length > 0 && (
            <span className={buttonStyle['active-groupby-label']}>
              {activeGroupBys.length === 1 && <FormattedMessage {...activeGroupBys[0].messageDescriptor} />}
              {activeGroupBys.length > 1 && (
                <FormattedMessage {...messages.multipleFieldsSelectedLabel} values={{ count: activeGroupBys.length }} />
              )}
            </span>
          )}
          <FontAwesomeIcon className={buttonStyle['dropdown-icon']} icon={faCaretDown} />
        </Button>
      )}
    </Popover>
  );
};

GroupByButton.propTypes = {
  onGroupByChanged: PropTypes.func,
  showIconButton: PropTypes.bool,
};

export default GroupByButton;
